import React, { useState, useEffect } from "react";
import AdminPrivateGuestsComponent from "../../components/AdminPrivateGuestsComponent/AdminPrivateGuestsComponent";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import { NotificationManager } from "react-notifications";
import { ContentBack } from "./AdminPrivateGuestsContainer.styled";
import {
  GET_GUESTS_FIRST,
  GET_GUESTS_AFTER,
  GET_GUESTS_BEFORE,
  DOWNLOAD_ATTENDEES,
  ALL_ACTIVE_COUNSELLING_THEME,
} from "../../GraphQL/Queries";
import { CHECK_ATTENDANCE, DELETE_PARTICIPANT } from "../../GraphQL/Mutations";
import { useLazyQuery, useMutation } from "@apollo/client";
import { clientWellness } from "../../App";
import { formatDate_ddmmyy } from "../../util/UtilityFunctions";
import { theme as themeConfig } from "../../themes/themes";

const AdminPrivateGuestsContainer = () => {
  const location = useLocation();
  const history = useHistory();
  const [allPages, setAllPages] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsPerPageOptions] = useState([5, 10, 20]);
  const [startCursor, setStartCursor] = useState("");
  const [endCursor, setEndCursor] = useState("");
  const [showLoader, setshowLoader] = useState(false);
  const [filtered, setFiltered] = useState(false);
  const [data, setdata] = useState([]);
  const [allAttended, setAllAttended] = useState(false);
  const [eventId] = useState(location.state.idEvent);
  const [nameEvent] = useState(location.state.nameEvent);
  const [eventDate] = useState(location.state.startDate);
  const [event] = useState(location.state.event);
  const [dataFilter, setDataFilter] = useState({});
  const [dataDownloadAttendees, setDataDownloadAttendees] = useState();
  const [allThemes, setAllThemes] = useState([]);
  const [runQueryDownloadAttendees] = useLazyQuery(DOWNLOAD_ATTENDEES, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      setDataDownloadAttendees(data.downloadAttendees.answers);
    },
  });

  const [runQueryAllCounselling] = useLazyQuery(ALL_ACTIVE_COUNSELLING_THEME, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      let list = data.allCounsellingThemes.nodes.map((e) => {
        return {
          value: e.idCounsellingTheme,
          label: e.themeName,
        };
      });
      setAllThemes(list);
    },
  });

  const [runCheckAttendance] = useMutation(CHECK_ATTENDANCE, {
    client: clientWellness,
  });

  useEffect(() => {
    runQueryAllCounselling();
  }, []);

  const asignData = (data) => {
    setAllPages(data.allParticipantsByEvent.totalCount);
    if (data.allParticipantsByEvent.pageInfo.hasNextPage === true) {
      setEndCursor(data.allParticipantsByEvent.pageInfo.endCursor);
    }
    if (data.allParticipantsByEvent.pageInfo.hasPreviousPage === true) {
      setStartCursor(data.allParticipantsByEvent.pageInfo.startCursor);
    }
    let allAttendance = true;
    let allParticipantsByEvent = data.allParticipantsByEvent.edges.map(
      (element) => {
        let dto = {
          id: element.node.userId,
          firstName: element.node.firstName,
          lastName: element.node.lastName,
          Email: element.node.email,
          country: element.node.countryIsoCode.toLowerCase(),
          city: element.node.cityName,
          registrationDate: new Date(
            element.node.registrationDate
          ).toLocaleString(),
          registrationDateFormatted: formatDate_ddmmyy(
            new Date(element.node.registrationDate)
          ),
          status: element.node.attendStatus,
          attendanceCheck: element.node.attendanceCheck,
          isDeletedUser: element.node.isDeletedUser,
        };
        if (!dto.attendanceCheck) {
          allAttendance = false;
        }
        return dto;
      }
    );
    setAllAttended(allAttendance);
    setdata(allParticipantsByEvent);
  };

  const [runQueryGetGuests, { loading: loadingFirstGuests }] = useLazyQuery(
    GET_GUESTS_FIRST,
    {
      client: clientWellness,
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        asignData(data);
        setshowLoader(false);
      },
    }
  );
  const [runQueryGetGuestsAfter] = useLazyQuery(GET_GUESTS_AFTER, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      asignData(data);
      setshowLoader(false);
    },
  });
  const [runQueryGetGuestsBefore] = useLazyQuery(GET_GUESTS_BEFORE, {
    client: clientWellness,
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      asignData(data);
      setshowLoader(false);
    },
  });

  const [deleteParticipant] = useMutation(DELETE_PARTICIPANT, {
    client: clientWellness,
  });

  const FilterEvents = (searchText) => {
    setFiltered(true);
    setPage(0);
    runQueryGetGuests({
      variables: {
        input: {
          eventId: eventId,
          cityId: dataFilter.city ? dataFilter.city : null,
          searchBy: searchText ? searchText : null,
          countryId: dataFilter.country ? dataFilter.country : null,
          attendStatus: dataFilter.status
            ? dataFilter.status.toUpperCase()
            : null,
        },
        first: rowsPerPage,
      },
    });
  };

  const handleChangePage = (event, newPage) => {
    if (newPage > page) {
      setshowLoader(true);
      runQueryGetGuestsAfter({
        variables: {
          input: {
            eventId: eventId,
            cityId: filtered && dataFilter.city ? dataFilter.city : null,
            searchBy: filtered && dataFilter.name ? dataFilter.name : null,
            countryId:
              filtered && dataFilter.country ? dataFilter.country : null,
            attendStatus:
              filtered && dataFilter.status ? dataFilter.status : null,
          },
          first: rowsPerPage,
          after: endCursor,
        },
      });
    }
    if (newPage < page) {
      setshowLoader(true);
      runQueryGetGuestsBefore({
        variables: {
          input: {
            eventId: eventId,
            cityId: filtered && dataFilter.city ? dataFilter.city : null,
            searchBy: filtered && dataFilter.name ? dataFilter.name : null,
            countryId:
              filtered && dataFilter.country ? dataFilter.country : null,
            attendStatus:
              filtered && dataFilter.status ? dataFilter.status : null,
          },
          last: rowsPerPage,
          before: startCursor,
        },
      });
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value ? parseInt(event.target.value) : 5);
    setPage(0);
    // setshowLoader(true)
    runQueryGetGuests({
      variables: {
        input: {
          eventId: eventId,
          cityId: filtered && dataFilter.city ? dataFilter.city : null,
          searchBy: filtered && dataFilter.name ? dataFilter.name : null,
          countryId: filtered && dataFilter.country ? dataFilter.country : null,
          attendStatus:
            filtered && dataFilter.status ? dataFilter.status : null,
        },
        first: event.target.value ? parseInt(event.target.value) : 5,
      },
    });
  };

  const hadleDeleteParticipant = (rowData) => {
    setshowLoader(true);
    deleteParticipant({
      variables: {
        eventId: eventId,
        userId: rowData.id,
      },
    }).then((response) => {
      setshowLoader(false);
      if (response.data.deleteParticipantFromEvent.userId == rowData.id) {
        let dto = JSON.parse(JSON.stringify(data));
        dto.splice(
          dto.findIndex(
            (i) => i.id == response.data.deleteParticipantFromEvent.userId
          ),
          1
        );
        let allAttendance = true;
        dto.map((e) => {
          if (!e.attendanceCheck) {
            allAttendance = false;
          }
        });
        setAllAttended(allAttendance);
        setdata(dto);
      } else {
        NotificationManager.error("Error to delete the guest", "", 5000);
      }
    });
  };

  const handleCheckAllAttendance = () => {
    runCheckAttendance({
      variables: {
        eventId: eventId,
        userId: data.map((e) => e.id),
        attendanceCheck: !allAttended,
      },
    })
      .then((response) => {
        if (response.data.checkAttendance) {
          const list = data.map((e) => {
            return {
              ...e,
              attendanceCheck: !allAttended,
            };
          });
          setAllAttended(!allAttended);
          setdata(list);
          NotificationManager.success(
            "Updated attendance status successfully",
            "",
            5000
          );
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let handleCheckAttendance = (rowData, attendanceCheck) => {
    runCheckAttendance({
      variables: {
        eventId: eventId,
        userId: [rowData.id],
        attendanceCheck: !attendanceCheck,
      },
    })
      .then((response) => {
        if (response.data.checkAttendance) {
          let allAttendance = true;
          const list = data.map((e) => {
            if (rowData.id === e.id) {
              if (e.attendanceCheck) {
                allAttendance = false;
              }
              return {
                ...e,
                attendanceCheck: !e.attendanceCheck,
              };
            }
            if (!e.attendanceCheck) {
              allAttendance = false;
            }
            return e;
          });
          setAllAttended(allAttendance);
          setdata(list);
          NotificationManager.success(
            "Updated attendance status successfully",
            "",
            5000
          );
        }
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);
      });
  };

  let handleDownloadAttendees = () => {
    runQueryDownloadAttendees({
      variables: {
        eventId: eventId,
      },
    }).catch((error) => {
      const errorMessage = error.message.split("\n")[0];
      NotificationManager.error(errorMessage, "", 5000);
    });
  };

  useEffect(() => {
    if (!filtered) {
      runQueryGetGuests({
        variables: {
          input: {
            eventId: eventId,
            cityId: null,
            searchBy: null,
            countryId: null,
            attendStatus: null,
          },
          first: rowsPerPage,
        },
      });
    }
  }, [filtered]);

  return (
    <div style={{ backgroundColor: themeConfig.neutral.white, minHeight: "89vh" }}>
      <ContentBack>
        <button
          onClick={() => {
            history.push({
              pathname: location.state.path,
            });
          }}
        >
          <ArrowBackIcon />
        </button>
        <span>
          <strong>Event Manager/</strong>
        </span>
        <span>Guests</span>
      </ContentBack>
      <AdminPrivateGuestsComponent
        data={data}
        event={event}
        fromPage={location.state.path}
        nameEvent={nameEvent}
        eventDate={eventDate}
        hadleDeleteParticipant={hadleDeleteParticipant}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions}
        rowsPerPage={rowsPerPage}
        page={page}
        allPages={allPages}
        handleCheckAttendance={handleCheckAttendance}
        dataDownloadAttendees={dataDownloadAttendees}
        handleDownloadAttendees={handleDownloadAttendees}
        FilterEvents={FilterEvents}
        setDataFilter={setDataFilter}
        filtered={filtered}
        setFiltered={setFiltered}
        allAttendend={allAttended}
        handleCheckAllAttendance={handleCheckAllAttendance}
        allThemes={allThemes}
      ></AdminPrivateGuestsComponent>
      {(showLoader || loadingFirstGuests) && <ModalLoader></ModalLoader>}
    </div>
  );
};
export default AdminPrivateGuestsContainer;
